// Imports
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import { useAppSelector } from '../../../../shareables/foundation/front-end/redux/hooks';
import ProfilePhoto from '../../shared-components/profile-photo';
import UserAvatar from '../../shared-components/user-avatar';
import memberNavigationItems from '../member-navigation-items';


// Styled components
const ProfileContainer = styled.div`
	grid-column: 1;
	margin-top: auto;
	margin-bottom: auto;
`;

const ProfileAvatar = styled(UserAvatar)`
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.1);
	
	width: 15vw;
	height: 15vw;
	margin-left: 1.5vw;
	margin-right: auto;
	
	font-size: 9vw;
`;

const MemberMenu = styled.div`
	grid-column: 2;
	max-width: 100%;
	
	ul {
		list-style-type: none;
		font-size: 0.9375rem;
		line-height: 1.25rem;
		
		li a {
			color: #fff;
			overflow-wrap: anywhere;
			
			.svg-inline--fa {
				padding-right: 0.1875rem;
				font-size: 0.875rem;
			}
		}
	}
`;

const Name = styled.span`
	font-size: 1.5625rem;
	line-height: 1.5625rem;
	overflow-wrap: anywhere;
`;

const Alert = styled.div`
	line-height: 1.25rem;
	
	.svg-inline--fa {
		padding-right: 0.1875rem;
		font-size: 0.875rem;
	}
`;


// Function component
const UserMenu: React.FC = () => {
	// Use Redux functionality
	const user = useAppSelector((state) => state.common.user);
	const member = useAppSelector((state) => state.self.member);
	const website = useAppSelector((state) => state.self.website);
	
	
	// If missing details, then display nothing
	if (!user || !website) {
		return null;
	}
	
	
	// Generate navigation menu JSX
	const navigationMenuJSX = memberNavigationItems(member, website).map((item) => {
		return (
			<li key={item.uniqueKey}>
				{item.type === 'link' ? (
					<Link to={item.to}>
						<FontAwesomeIcon icon={item.icon} fixedWidth />
						{item.content}
					</Link>
				) : (
					<a href={item.to}>
						<FontAwesomeIcon icon={item.icon} fixedWidth />
						{item.content}
					</a>
				)}
			</li>
		);
	});
	
	
	// Return JSX
	return (
		<React.Fragment>
			<ProfileContainer>
				{user.profilePhotoURL ? (
					<ProfilePhoto alt='Profile photo' src={user.profilePhotoURL} size='75%' />
				) : (
					<ProfileAvatar
						aria-label='Profile photo'
						firstName={user.firstName ?? ''}
						lastName={user.lastName ?? ''}
						round
					/>
				)}
			</ProfileContainer>
			
			<MemberMenu>
				<Name>{member?.names.member ?? user.name}</Name>
				
				{member && (!member.account?.approved || member.account.suspended) && (
					<Alert>
						<FontAwesomeIcon icon={faExclamationTriangle} fixedWidth />
						Account {member?.account?.suspended ? 'suspended' : 'pending review'}
					</Alert>
				)}
				
				<ul>{navigationMenuJSX}</ul>
			</MemberMenu>
		</React.Fragment>
	);
};

export default UserMenu;
